import { useMemo } from "react";
import { Combobox } from "@/components/Combobox";
import { TR_PROVINCES, TR_DISTRICTS } from "@/data/trCities";

const trLower = (s) => String(s || "").replace(/İ/g, "i").replace(/I/g, "ı").toLocaleLowerCase("tr");
// ASCII yazılmış iller ("ISTANBUL", "IZMIR") da eşleşsin → Türkçe harfler katlanır
const fold = (s) => trLower(s).replace(/ı/g, "i").replace(/ş/g, "s").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ö/g, "o").replace(/ç/g, "c").trim();
const PROV_INDEX = TR_PROVINCES.reduce((m, p) => { m[fold(p)] = p; return m; }, {});

// Kayıtlı il adını (ör. "İSTANBUL" / "ISTANBUL") resmi yazıma ("İstanbul") eşler; eşleşmezse olduğu gibi döner.
export const normalizeProvince = (name) => PROV_INDEX[fold(name)] || (name || "");
export const districtsOf = (city) => TR_DISTRICTS[normalizeProvince(city)] || [];

// Resmi il listesinden aranabilir açılır seçim. Listede olmayan değer de yazılabilir (allowCustom).
export function ProvinceSelect({ value, onChange, ...props }) {
  const options = useMemo(() => TR_PROVINCES.map((p) => ({ value: p, label: p })), []);
  return (
    <Combobox options={options} value={value} onChange={onChange} allowCustom
      placeholder="İl seçin / arayın" searchPlaceholder="İl ara..." emptyText="İl bulunamadı"
      className="h-9 bg-white" {...props} />
  );
}

// Seçili ile göre ilçe listesi; il seçilmeden pasiftir.
export function DistrictSelect({ city, value, onChange, ...props }) {
  const list = districtsOf(city);
  const options = useMemo(() => list.map((d) => ({ value: d, label: d })), [list]);
  const disabled = list.length === 0;
  return (
    <Combobox options={options} value={value} onChange={onChange} allowCustom disabled={disabled}
      placeholder={disabled ? "Önce il seçin" : "İlçe seçin / arayın"} searchPlaceholder="İlçe ara..." emptyText="İlçe bulunamadı"
      className="h-9 bg-white" {...props} />
  );
}
